import React from 'react';
import type { ReactElement, ReactNode } from 'react';

import classnames from 'classnames';

import styles from './BreadcrumbItemText.module.scss';

type BreadcrumbItemTextProps = {
    children: ReactNode;
    className?: string;
};

export const BreadcrumbItemText = ({
    children,
    className,
    ...rest
}: BreadcrumbItemTextProps): ReactElement => {
    return (
        <div className={classnames(styles.container, className)} {...rest}>
            {children}
        </div>
    );
};
